export const mfaTypeMap = {
  email: "Email:",
  sms: "Text Message:",
};
